export default function Footer() {
  return (
    <footer className="bg-black border-t border-gray-800 py-16">
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-8">
          {/* Brand */}
          <div className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/c552d6b895eeb1ca6a26a787763818ee/5319e48af1dac71fd7a1481fc0b376b7.png" 
              alt="THRESH" 
              className="h-8 w-auto"
            />
          </div>

          {/* Links */}
          <div className="flex items-center gap-10">
            <a
              href="#privacy"
              className="text-sm text-gray-400 hover:text-[#00FF88] transition-colors cursor-pointer"
            >
              Privacy Policy
            </a>
            <a
              href="#terms"
              className="text-sm text-gray-400 hover:text-[#00FF88] transition-colors cursor-pointer"
            >
              Terms
            </a>
            <a
              href="#contact"
              className="text-sm text-gray-400 hover:text-[#00FF88] transition-colors cursor-pointer"
            >
              Contact
            </a>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-12 text-center">
          <p className="text-sm text-gray-500">
            © 2025 THRESH. Train Hard. Fuel Smart. Cross Your Threshold.
          </p>
        </div>
      </div>
    </footer>
  );
}